import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroupDirective, Validators } from '@angular/forms';
import { toasterMessages } from '@messages/*';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})

export class ContactUsComponent implements OnInit {

  isSubmitting = false;

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private toastr: ToastrService
  ) { }

  contactForm = this.fb.group({
    name: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    message: ['', Validators.required],
    additionalDetails: ['']
  });

  ngOnInit(): void { }

  submit(formDirective: FormGroupDirective) {
    if (this.contactForm.invalid || this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    this.contactForm.value.name = this.contactForm.value.name?.trim();
    this.contactForm.value.email = this.contactForm.value.email.toLowerCase();

    this.apiService.sendEmail(this.contactForm.value).subscribe(() => {
      this.isSubmitting = false;
      this.contactForm.reset(); // Reset form data
      formDirective.resetForm(); // clear validations.
      this.toastr.success(toasterMessages.contactEmailSentSuccess);
    }, () => {
      this.isSubmitting = false;
      this.toastr.error(toasterMessages.contactEmailSentFailed);
    });
  }

  openEmailClient(): void {
    // Ensure the mailto link opens properly
    window.location.href = 'mailto:support@evaltrix.com';
  }

}
